"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StripeSessionIdSchema = exports.StripeChangeMembershipSchema = exports.StripeUpcomingInvoiceSchema = exports.StripeCheckoutSessionSchema = exports.StripeSessionSchema = void 0;
var zod_1 = require("zod");
exports.StripeSessionSchema = zod_1.z.object({
    id: zod_1.z.string(),
    object: zod_1.z.string(),
    after_expiration: zod_1.z.any().nullable(),
    allow_promotion_codes: zod_1.z.any().nullable(),
    amount_subtotal: zod_1.z.number(),
    amount_total: zod_1.z.number(),
    automatic_tax: zod_1.z.object({
        enabled: zod_1.z.boolean(),
        liability: zod_1.z.any().nullable(),
        status: zod_1.z.any().nullable(),
    }),
    billing_address_collection: zod_1.z.any().nullable(),
    cancel_url: zod_1.z.any().nullable(),
    client_reference_id: zod_1.z.any().nullable(),
    client_secret: zod_1.z.any().nullable(),
    consent: zod_1.z.any().nullable(),
    consent_collection: zod_1.z.any().nullable(),
    created: zod_1.z.number(),
    currency: zod_1.z.string(),
    currency_conversion: zod_1.z.any().nullable(),
    custom_fields: zod_1.z.array(zod_1.z.unknown()),
    custom_text: zod_1.z.object({
        after_submit: zod_1.z.any().nullable(),
        shipping_address: zod_1.z.any().nullable(),
        submit: zod_1.z.any().nullable(),
        terms_of_service_acceptance: zod_1.z.any().nullable(),
    }),
    customer: zod_1.z.string(),
    customer_creation: zod_1.z.string(),
    customer_details: zod_1.z.object({
        address: zod_1.z.object({
            city: zod_1.z.any().nullable(),
            country: zod_1.z.string(),
            line1: zod_1.z.any().nullable(),
            line2: zod_1.z.any().nullable(),
            postal_code: zod_1.z.any().nullable(),
            state: zod_1.z.any().nullable(),
        }),
        email: zod_1.z.string(),
        name: zod_1.z.string(),
        phone: zod_1.z.any().nullable(),
        tax_exempt: zod_1.z.string(),
        tax_ids: zod_1.z.array(zod_1.z.unknown()),
    }),
    customer_email: zod_1.z.any().nullable(),
    expires_at: zod_1.z.number(),
    invoice: zod_1.z.string(),
    invoice_creation: zod_1.z.any().nullable(),
    livemode: zod_1.z.boolean(),
    locale: zod_1.z.any().nullable(),
    metadata: zod_1.z.object({}),
    mode: zod_1.z.string(),
    payment_intent: zod_1.z.any().nullable(),
    payment_link: zod_1.z.any().nullable(),
    payment_method_collection: zod_1.z.string(),
    payment_method_configuration_details: zod_1.z.any().nullable(),
    payment_method_options: zod_1.z.object({
        card: zod_1.z.object({ request_three_d_secure: zod_1.z.string() }),
    }),
    payment_method_types: zod_1.z.array(zod_1.z.string()),
    payment_status: zod_1.z.string(),
    phone_number_collection: zod_1.z.object({ enabled: zod_1.z.boolean() }),
    recovered_from: zod_1.z.any().nullable(),
    redirect_on_completion: zod_1.z.string(),
    return_url: zod_1.z.string(),
    saved_payment_method_options: zod_1.z.any().nullable(),
    setup_intent: zod_1.z.any().nullable(),
    shipping_address_collection: zod_1.z.any().nullable(),
    shipping_cost: zod_1.z.any().nullable(),
    shipping_details: zod_1.z.any().nullable(),
    shipping_options: zod_1.z.array(zod_1.z.unknown()),
    status: zod_1.z.string(),
    submit_type: zod_1.z.any().nullable(),
    subscription: zod_1.z.string(),
    success_url: zod_1.z.any().nullable(),
    total_details: zod_1.z.object({
        amount_discount: zod_1.z.number(),
        amount_shipping: zod_1.z.number(),
        amount_tax: zod_1.z.number(),
    }),
    ui_mode: zod_1.z.string(),
    url: zod_1.z.any().nullable(),
});
exports.StripeCheckoutSessionSchema = zod_1.z.object({
    priceId: zod_1.z.string(),
    membershipStatusId: zod_1.z.string(),
    customer_email: zod_1.z.string().email().optional(),
    currency: zod_1.z.string().optional().default('eur'),
    upgrade: zod_1.z.boolean().optional(),
});
exports.StripeUpcomingInvoiceSchema = zod_1.z.object({
    proration_date: zod_1.z.coerce.date(),
    subscriptionId: zod_1.z.string(),
    itemId: zod_1.z.string(),
    newPriceId: zod_1.z.string(),
    customerId: zod_1.z.string(),
});
//itemId, newPriceId, proration_date, subscriptionId
exports.StripeChangeMembershipSchema = zod_1.z
    .object({
    membershipStatusId: zod_1.z.string(),
    membershipRateId: zod_1.z.string(),
})
    .merge(exports.StripeUpcomingInvoiceSchema)
    .omit({ customerId: true });
exports.StripeSessionIdSchema = zod_1.z.object({
    clientSecret: zod_1.z.string(),
    id: zod_1.z.string(),
});
//# sourceMappingURL=Stripe.js.map